module.exports = __webpack_public_path__ + "img/banner_vi.7952b8a9.png";